import React, { useEffect, useState } from "react";
import Style from "../../style/allEvent.module.scss";
import EventFilterLeft from "./EventFilterLeft";
import EventFilterMiddle from "./EventFilterMiddle";
import EventFilterRight from "./EventFilterRight";

const AllEvent = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    fetch("/data/event.json")
      .then((res) => res.json())
      .then((res) => {
        setData(res.events);
      });
  }, []);

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <h1 className={Style.pageTitle}>All Events</h1>
        <div className={Style.Divide}>
          <div className={Style.leftSide}>
            <EventFilterLeft itemList={data} onDateFilter={() => {}} />
          </div>

          <div className={Style.middle}>
            <EventFilterMiddle itemList={data} />
          </div>

          <div className={Style.rightSide}>
            <EventFilterRight itemList={data} filteredData={[]} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllEvent;
